import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiAuth } from '../auth-client';
const KEY = ['auth', 'services'];
export function useAuthServices() {
    return useQuery({
        queryKey: KEY,
        queryFn: () => apiAuth('/admin/services'),
        // Service list is small (<50 rows in any realistic deployment) and rarely
        // changes — 30s baseline + bg-pause is plenty. Mutations invalidate
        // immediately for the optimistic feel.
        refetchInterval: 30_000,
        refetchIntervalInBackground: false,
    });
}
export function useAuthService(slug) {
    return useQuery({
        queryKey: ['auth', 'services', slug],
        queryFn: () => apiAuth(`/admin/services/${slug}`),
        enabled: !!slug,
    });
}
export function useCreateAuthService() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (body) => apiAuth('/admin/services', { method: 'POST', body }),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: KEY });
        },
    });
}
export function useUpdateAuthService() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ slug, body }) => apiAuth(`/admin/services/${slug}`, { method: 'PATCH', body }),
        onSuccess: (_data, { slug }) => {
            qc.invalidateQueries({ queryKey: KEY });
            qc.invalidateQueries({ queryKey: ['auth', 'services', slug] });
        },
    });
}
export function useDeleteAuthService() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (slug) => apiAuth(`/admin/services/${slug}`, { method: 'DELETE' }),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: KEY });
        },
    });
}
